import React from 'react';
import { useTranslation } from 'react-i18next';
import { MotionModal } from '../../../components/motion-modal/motion-modal';
import { useCancelProgramRecording, useRecordProgram } from '../../../queries/ats/recordings/mutations';
import { SingleRecording } from '../../../queries/ats/recordings/types/recording';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { ProgramSource } from '../../../queries/ats/titles/types/sources';
import { isLive } from '../../../queries/ats/titles/utils/sources-utils';
import { useRecordQueue } from './record-queue';
import { getDeleteMode } from './utils';

interface RecordProgramButtonProps {
  asset: Asset;
  source: ProgramSource;
}

export function RecordProgramButton({ asset, source }: RecordProgramButtonProps) {
  const { t } = useTranslation('recordings');
  const queue = useRecordQueue();

  const { mutateAsync: recordProgram, isLoading: isRecordLoading } = useRecordProgram(asset);

  const deleteMode = getDeleteMode(source.recordings);

  return (
    <MotionModal.Button
      onClick={async () => {
        queue.push('record-program');
        await recordProgram({ source, deleteMode });
        queue.pop('record-program');
      }}
      isLoading={isRecordLoading}
      isDisabled={queue.size > 0}
    >
      {isLive(source) ? t('record-program-from-start') : t('record-program')}
    </MotionModal.Button>
  );
}

export interface SingleRecordingButtonProps {
  recording: SingleRecording;
}

export function SingleRecordingButton({ recording }: SingleRecordingButtonProps) {
  const { t } = useTranslation('recordings');
  const queue = useRecordQueue();

  const { mutateAsync: cancelProgram, isLoading: isCancelLoading } = useCancelProgramRecording();

  return (
    <MotionModal.Button
      onClick={async () => {
        queue.push('cancel-record-program');
        await cancelProgram(recording.id);
        queue.pop('cancel-record-program');
      }}
      isDisabled={isCancelLoading}
      isLoading={isCancelLoading}
    >
      {t('cancel-program-recording')}
    </MotionModal.Button>
  );
}
